import apiClient from './apiClient';

const getUser = async () => {
  try {
    const response = await apiClient.get('/users/me');
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export { getUser };
